//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import BrigadeMapTaskCard from './BrigadeMapTaskCard.vue'
import BrigadeMapTasksList from './BrigadeMapTasksList.vue'
import { brigadeMapTasksListUtils } from './BrigadeMapTasksListUtils.js'

export default {
  components: {
    BrigadeMapTaskCard,
    BrigadeMapTasksList
  },
  mixins: [brigadeMapTasksListUtils],
  props: {
    closestRequests: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data: function () {
    return {
      closestRequestsConfig: null
    }
  },
  watch: {
    closestRequests: {
      handler: function (requests) {
        this.prepareRequestsListConfig('closestRequestsConfig', requests)
      },
      immediate: true
    }
  }
}

